import { enEmployee } from '../en';
import { frEmployee } from '../fr';
import { esEmployee } from '../es';
import { deEmployee } from '../de';

export const employeeModuleTranslations = {
  en: enEmployee,
  fr: frEmployee,
  es: esEmployee,
  de: deEmployee,
} as const;

